module.exports = __webpack_public_path__ + "img/bg4.da1ea20d.png";